import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propFunc, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitHeaderCategory from './ProfessionalUnitHeaderCategory';
const ProfessionalUnitHeaderCategories = (props) => {
    const { categories, onClickCategory } = props;
    // 表示可能なカテゴリが少なすぎる場合は非表示
    const isNotEnough = useMemo(() => categories.filter((v) => v.count > 0).length < 3, [categories]);
    if (isNotEnough) {
        return null;
    }
    return (_jsx("ul", Object.assign({ className: 'header_categories' }, { children: categories.map((v) => (_jsx(ProfessionalUnitHeaderCategory, { item: v, onClick: onClickCategory }, v.value))) })));
};
ProfessionalUnitHeaderCategories.propTypes = {
    categories: propArrayShape().isRequired,
    onClickCategory: propFunc().isRequired,
};
export default ProfessionalUnitHeaderCategories;
